export class PreferenceType {
    preferenceCode: string;
    deliveryPreference: number;
    preferenceCodeMF: string;
}
